import { AddressInfoFieldsNames } from 'FormDefinitions/AddressInfoForm/AddressInfoFields'
import { BasicInfoFieldsNames } from 'FormDefinitions/BasicInfoForm/BasicInfoFields'
import { CollectPersonalIdFieldsNames } from 'FormDefinitions/CollectPersonalIdForm/CollectPersonalIdFields'
import { ExtendedInfoFieldsNames } from 'FormDefinitions/ExtendedInfoForm/ExtendedInfoFields'
import { MObywatelExtendedInfoFieldsNames } from 'FormDefinitions/MObywatelExtendedInfoForm/MObywatelExtendedInfoFields'


// ============= TYPY KLAWIATUR NA URZĄDZENIACH MOBILNYCH =============
// Atrybuty według specyfikacji: https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/inputmode

export enum InputModes {
   text = 'text',
   decimal = 'decimal',
   numeric = 'numeric',
   tel = 'tel',
   search = 'search',
   email = 'email',
   url = 'url',
   none = 'none'
 }


 // ============= WARTOŚCI DO AUTOUZUPEŁNIANIA =============
// Atrybuty według specyfikacji: https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete#values
 export enum AutocompleteValues {
   Off = 'off',
   On = 'on',
   FirstName = 'given-name',
   Surname = 'family-name',
   Email = 'email',
   Phone = 'tel-national',
   PostalCode = 'postal-code',
   City = 'address-level2',
   Street = 'address-line1',
   HouseNumber = 'address-line2',
   ApartamentNumber = 'address-line3'
 }


// ========================== Typ obiektu wszystkich pól ============================

export type TFieldsType = IFieldText | IFieldTextWithAutocomplete | IFieldNumber | IFieldDate
export type TFieldsObjectNames = 
           keyof typeof BasicInfoFieldsNames 
         | keyof typeof ExtendedInfoFieldsNames 
         | keyof typeof AddressInfoFieldsNames 
         | keyof typeof MObywatelExtendedInfoFieldsNames
         | keyof typeof CollectPersonalIdFieldsNames;


export type TFieldValues = string | number;

export type BasicInfoFieldsRecord = Record<keyof typeof BasicInfoFieldsNames, TFieldsType>
export type ExtendedInfoFieldsRecord = Record<keyof typeof ExtendedInfoFieldsNames, TFieldsType>
export type AddressInfoFieldsRecord = Record<keyof typeof AddressInfoFieldsNames, TFieldsType>
export type MObywatelExtendedInfoFieldsRecord = Record<keyof typeof MObywatelExtendedInfoFieldsNames, TFieldsType>
export type CollectPersonalIdFieldsRecord = Record<keyof typeof CollectPersonalIdFieldsNames, TFieldsType>

export type IFields =  BasicInfoFieldsRecord | ExtendedInfoFieldsRecord | AddressInfoFieldsRecord | MObywatelExtendedInfoFieldsRecord | CollectPersonalIdFieldsRecord




export interface IFieldBase {
   order?: number;
   name: TFieldsObjectNames;
   placeholder?: string;
   label: string;
   mask?: string;
   validation?: any; //TODO ZMIENIĆ TYP
   visible: boolean;
   parser?: (newValue: string) => string;
   inputMode?: keyof typeof InputModes;
   browserAutocomplete?: AutocompleteValues;
   maxLength?: number;
   isPasteDisabled?: boolean;
   fullWidthInput?: boolean;
   
   onBlurHandler?: Function;
}


export interface IFieldText extends IFieldBase {
   type: FieldTypes.string;
   value?: string;
}

export interface IFieldTextWithAutocomplete extends Omit<IFieldText, 'isAutocomplete' | 'type'> {
   type: FieldTypes.stringAutocomplet;
   getOptionsFunction: (currentValue: string) => string[];
}

export interface IFieldNumber extends IFieldBase {
   type: FieldTypes.number;
   value?: number;
}

export interface IFieldDate extends IFieldBase {
   type: FieldTypes.date;
   value?: string;
}


// ============================== TYPY PÓL ====================
export enum FieldTypes {
   string = 'string',
   stringAutocomplet = 'stringAutocomplete',
   email = 'email',
   phone = 'phone',
   number = 'number',
   date = 'date'
 }